import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from '@Sage/hoi-poi-ui';
import { SALESORDERS } from 'constants/Entities';
import Context from 'managers/Context';
import { getActiveCrud } from 'utils/crud';
import { getLiteral } from 'utils/getLiteral';
import { successToast, errorToast } from 'utils/toast';

const useSalesOrdersCrud = () => {
    const [panelWidth, setPanelWidth] = useState('');
    const dispatch = useDispatch();
    const { config: { permission } = {} } = Context.store.getState();


    const handleResize = useCallback(() => {
        let width = window.innerWidth - 350;
        if (width > 1200) width = 1200;
        setPanelWidth(`${width}px`);
    }, []);

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);

    const getCanDelete = useCallback(() => {
        const state = Context.store.getState();
        const active = getActiveCrud(state);
        const id = active?.id || null;
        const crudPermissions =
            state.config.permission.crud_permission[SALESORDERS.permission] || null;
        return id && crudPermissions && crudPermissions.delete;
    }, []);

    const changeList = useCallback(
        (salesOrderType) => {
            dispatch(Context.actions.ServerListActions.getList('tblTiposSalesOrders')).then(
                (data) => {
                    const item = data.find((item) => String(item.value) === salesOrderType);
                    dispatch(
                        Context.actions.EntityFiltersActions.changeFilter({
                            entity: SALESORDERS,
                            filter: {
                                id: 'salesOrderType',
                                noCacheCheck: true,
                                hideForCount: true,
                            },
                            value: [item],
                        }),
                    );
                },
            );
        },
        [dispatch],
    );

    const onSave = useCallback(
        (result, data) => {
            const state = Context.store.getState();
            let toastLiteral = 'succes_entitycreatedsuccessfully';
            if (result?.Updated?.num === '1') toastLiteral = 'succes_entityupdatedsuccessfully';
            let text = getLiteral(toastLiteral);
            const salesOrderType = String(
                state.entityFilters[SALESORDERS.entity]?.filters?.salesOrderType?.value?.[0]?.value,
            );
            const dataSalesOrderType = String(data.salesOrderType?.value || data.salesOrderType);
            if (salesOrderType !== dataSalesOrderType && dataSalesOrderType)
                text = (
                    <div>
                        {getLiteral(text)}
                        <br />
                        <br />
                        <Link
                            onClick={() => changeList(dataSalesOrderType)}
                            underline
                            type="caption"
                            className="fm-toast-view"
                        >
                            {getLiteral('label_notification_see_salesorders')}
                        </Link>
                    </div>
                );
            successToast({
                text,
            });
        },
        [changeList],
    );

    const onErrorSave = useCallback((data) => {
        let toastLiteral = 'label_failed_create';
        if (data.id) toastLiteral = 'label_failed_update';
        errorToast({
            text: getLiteral(toastLiteral),
        });
    }, []);

    const getInfo = useCallback(
        (data) => {
            if (!data?.companyWarning) return null;
            if (!permission.warnings) return null;
            if (!permission.editWarnings && !permission.viewWarningsInSalesOrders) return null;
            return data.companyWarning;
        },
        [permission.editWarnings, permission.viewWarningsInSalesOrders, permission.warnings],
    );

    return {
        entity: SALESORDERS,
        width: panelWidth,
        className: 'fm-sales-orders-crud',
        literalNewEntity: 'title_add_salesorder',
        literalEditEntity: 'label_editing_salesorders',
        getNewEntityLiteral: null,
        getEditEntityLiteral: null,
        onSave,
        onErrorSave,
        onDelete: undefined,
        onErrorDelete: undefined,
        hasCrudInDetail: true,
        getCanDelete,
        deleteProps: undefined,
        literalsBulk: undefined,
        getInfo,
    };
};

export default useSalesOrdersCrud;
